export const ATTRIBUTES = Symbol('ATTRIBUTES')

export const COMPONENT = Symbol('COMPONENT')

export const FOR = Symbol('FOR')

export const REFERENCES = Symbol('REFERENCES')
export const REFERENCES_CACHE = Symbol('REFERENCES_CACHE')
